import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
const SignupGateRequestSchema = z.object({
    code: z.string().min(1, 'Code is required'),
});
const SignupGateResponseSchema = z.object({
    valid: z.boolean(),
});
export const authContract = c.router({
    signupGate: {
        method: 'POST',
        path: '/auth/signup-gate',
        summary: 'Validate invite code for signup',
        body: SignupGateRequestSchema,
        responses: {
            200: SignupGateResponseSchema,
            400: z.object({
                message: z.string(),
                statusCode: z.number(),
            }),
        },
    },
});
//# sourceMappingURL=auth.js.map